import { Locale } from "./locale.config";

type EnvConfig = {
  localeConfig: { [locale in Locale]: {
    url: string,
  } };
  softwareCenterUrl: string,
};

const buildEnvConfig = (
  envDomain: string,
  reverseMicroServiceUrls = false,
  forceFRUrlInAllDomains = false,
): EnvConfig => {
  const frUrl = `https://fr.${envDomain}.appvizer.net`;
  const getDomainUrl = (domainUrl: string) => forceFRUrlInAllDomains ? frUrl : domainUrl;

  return {
    softwareCenterUrl: reverseMicroServiceUrls ? `https://${envDomain}.software.appvizer.net` : `https://software.${envDomain}.appvizer.net`,
    localeConfig: {
      en_US: {
        url: getDomainUrl(`https://com.${envDomain}.appvizer.net`)
      },
      pt_BR: {
        url: getDomainUrl(`https://br.${envDomain}.appvizer.net`)
      },
      de_DE: {
        url: getDomainUrl(`https://de.${envDomain}.appvizer.net`)
      },
      en_GB: {
        url: getDomainUrl(`https://uk.${envDomain}.appvizer.net`)
      },
      it_IT: {
        url: getDomainUrl(`https://it.${envDomain}.appvizer.net`)
      },
      fr_FR: {
        url: frUrl
      },
      es_ES: {
        url: getDomainUrl(`https://es.${envDomain}.appvizer.net`)
      }
    }
  };
};

const ENV_CONFIG: { [env: string]: EnvConfig } = {
  prod: {
    softwareCenterUrl: 'https://software.appvizer.com',
    localeConfig: {
      en_US: {
        url: "https://www.appvizer.com"
      },
      pt_BR: {
        url: "https://www.appvizer.com.br"
      },
      de_DE: {
        url: "https://www.appvizer.de"
      },
      en_GB: {
        url: "https://www.appvizer.co.uk"
      },
      it_IT: {
        url: "https://www.appvizer.it"
      },
      fr_FR: {
        url: "https://www.appvizer.fr"
      },
      es_ES: {
        url: "https://www.appvizer.es"
      }
    }
  },
  sandbox: buildEnvConfig('sandbox', true)
} as const;

export const getEnvConfig = (envKey: string | null | undefined) =>
  envKey ?
    (ENV_CONFIG[envKey] || buildEnvConfig(envKey, false, true)) :
    ENV_CONFIG.sandbox;
